import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  ViewChild,
  ElementRef,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';

import { Store, select } from '@ngrx/store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import {
  AdvancedSortableDirective,
  SortEvent,
} from 'src/app/modules/acbcr/directives/advanced-sortable.directive';
import { RaportIncasare } from 'src/app/modules/acbcr/common/models/rapoarte-incasari.model';
import { RapoarteIncasariTableService } from 'src/app/modules/acbcr/common/services/rapoarte-incasari.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { RapoarteContabilitateTableService } from 'src/app/modules/acbcr/common/services/contabilitate-rapoarte.service';
import { RapoarteFacturiEmiseTableService } from 'src/app/modules/acbcr/common/services/rapoarte-facturi-emise.service';

@Component({
  selector: 'app-raport-facturi-emise-table',
  templateUrl: './raport-facturi-emise-table.component.html',
  styleUrls: ['./raport-facturi-emise-table.component.scss'],
})
export class RaportFacturiEmiseTableComponent implements OnInit {
  @ViewChildren(AdvancedSortableDirective) headers: QueryList<
    AdvancedSortableDirective
  >;
  @ViewChild('rapoarteFacturiEmiseTable', { static: false })
  rapoarteFacturiEmiseTable: ElementRef;

  @Input() rapoarteFacturiEmise: any[];
  @Input() rapoarteFacturiEmiseLength: number;
  @Input() loadingDataSpinner: boolean;
  @Input() totalRestant;

  @Output() filterData = new EventEmitter();
  @Output() exportData = new EventEmitter();
  @Output() pageSizeChanged = new EventEmitter();
  @Output() pageNumberChanged = new EventEmitter();
  @Output() rapoarteFacturiEmiseTableCallback = new EventEmitter();

  readonly modalType = 'rapoarte-facturi-emise';
  openSearchModal = new Subject<boolean>();

  currentRoute: string;
  destroy$: Subject<boolean> = new Subject<boolean>();
  isAutoritateJudeteana = false;
  isContabil = false;
  filteredRapoarte;
  isDataFiltered = false;

  constructor(
    public rapoarteFacturiEmiseTableService: RapoarteFacturiEmiseTableService,
    private store: Store<ApplicationState>,
    private helperDataService: HelperDataService
  ) {}

  ngOnInit(): void {
    this.store
      .pipe(select(getCurrentRoute))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: string) => {
        this.currentRoute = response;
      });
    this.isAutoritateJudeteana = UIHelper.isAutoritateJudeteana();
    this.isContabil = UIHelper.isContabil();
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });
    this.rapoarteFacturiEmiseTableService.sortColumn = column;
    this.rapoarteFacturiEmiseTableService.sortDirection = direction;
  }

  changeTableRows(event) {
    this.pageSizeChanged.emit(event.target.value);
  }

  changeTablePage(event) {
    this.pageNumberChanged.emit(event);
  }

  openTableSearchModal() {
    this.openSearchModal.next(true);
  }

  filterSearch(event) {
    this.filterData.emit(event);
    this.filteredRapoarte = event;
    // check if a filter was made
    this.isDataFiltered = !Object.values(this.filteredRapoarte).every(
      (o) => o === null
    );
  }

  exportTableXLSX() {
    this.exportData.emit(null);
  }

  getModalResult(event) {
    this.rapoarteFacturiEmiseTableCallback.emit(event);
  }
}
